import { render, staticRenderFns } from "./AddCharges.vue?vue&type=template&id=7e51d9dc&"
import script from "./AddCharges.vue?vue&type=script&lang=js&"
export * from "./AddCharges.vue?vue&type=script&lang=js&"
import style0 from "./AddCharges.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports